<script>
import { Helper } from '@/mixin/helper'
import RestEditableTableV2 from '@/components/RestEditableTableV2'
import * as vehicleCategoryApi from '@/services/rest-api-sms/lib/vehicle/vehicle-category'
import i18n from '@/i18n'

export default {
  components: {
    RestEditableTableV2,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    fields() {
      return [
        {
          key: 'category',
          label: i18n.t('master.form.fleet.fleetCategory'),
          placeholder: i18n.t('master.form.fleet.fleetCategory'),
          isEditable: true,
          isSortable: false,
          validation: [['required']],
          thClass: 'mc-table--500',
        },
        {
          key: 'icon',
          inputName: 'illustration',
          label: i18n.t('master.list.fleetCategory.illustration'),
          placeholder: 'Pilih ' + i18n.t('master.list.fleetCategory.illustration'),
          isSortable: false,
          isEditable: true,
          hasImage: true,
          type: 'select-resourceful',
          trackBy: 'value',
          optionsGetter: this.resourcefulQuery.icons,
          optionLabelFn: ({ item }) => {
            return {
              label: item?.icon?.label,
              value: item?.icon?.value,
              img: item?.icon?.img,
              style: item?.icon?.style,
            }
          },
          getInitialObject: (item) => {
            return {
              label: item?.icon?.label,
              value: item?.icon?.value,
              img: item?.icon?.img,
              style: item?.icon?.style,
            }
          },
          customValueFn: (item) => item?.icon?.value ?? '',
          customColumn: true,
          validation: [['required']],
          thClass: 'mc-table--500',
          thStyle: 'width: 500px',
        },
      ]
    },

    resourcefulQuery() {
      return {
        icons: async (opts) => {
          let result = {}
          if (opts && opts.page !== 1) {
            result = {
              metadata: {
                total_page: 1,
                total_count: 0,
                page: 1,
              },
              data: {
                paginated_result: [],
              },
            }
          } else {
            let iconOptions = vehicleCategoryApi.constants.data.iconOptions
            if (opts && opts.search) {
              iconOptions = iconOptions.filter((item) => this.isContains(opts.search, item.label))
            }
            result = {
              metadata: {
                total_page: 1,
                total_count: iconOptions?.length,
                page: 1,
              },
              data: {
                paginated_result: iconOptions,
              },
            }
          }
          return result
        },
      }
    },

    apiClient() {
      return {
        get: vehicleCategoryApi.get,
        store: vehicleCategoryApi.store,
        delete: vehicleCategoryApi.deleteMany
      }
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    async handleChange() {
      const fleetCategoryRef = this.$refs.fleetCategoryRef.$refs
      await this.$nextTick()
      this.fields.forEach(field => {
        if (!field.isEditable) return
        fleetCategoryRef[`${field.key}-ref`].$el.addEventListener('keydown', Helper.methods.preventTabKey)
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <RestEditableTableV2
          ref="fleetCategoryRef"
          v-show="isTableDataAvailable"
          searchable
          :fields="fields"
          :apiClient="apiClient"
          :bulkDeleteApi="true"
          @available-change="handleDataAvailable"
          trackBy="category"
          :idIsString="true"
          @changeData="handleChange"
        >
          <template #icon="data">
            <img v-if="data.value.value === 'person'" :src="data.value.img" :alt="data.value.value" />
            <img v-else :src="data.value.img" style="transform: rotate(270deg)" :alt="data.value.value" />
          </template>
        </RestEditableTableV2>
      </div>
    </div>
  </div>
</template>
